function isSceneObject(obj) {
  return obj.useState !== void 0;
}

export { isSceneObject };
//# sourceMappingURL=types.js.map
